import {createSlice} from '@reduxjs/toolkit'

const initialState = {
	userData: {
		oldPassword: '',
		newPassword: '',
		confirmPassword: '',
		securityQns: '',
		securityAns: ''	,
	},
	userSecurityQuestionAnswers:[{
		answer: "",
		question: ""
		}],
	passwordForUpdateAnswer: {
		currentPassword: ''
	},
	accountLoginHistories: [],
  }

export const PasswordSecuritySlice = createSlice({
	name: 'PasswordSecuritySlice',
    initialState: initialState,
	reducers: {
		updatePassWord: (state, { payload }) => {
			const {name, value} = payload;
			state.userData[name] = value;
		},
		onUpdateFetchDataQuestionAndAnswer: (state, { payload }) => {
			state.userSecurityQuestionAnswers = payload
		},
		onPushQuestionAndAnswer: (state, { payload }) => {
			state.userSecurityQuestionAnswers.push(payload);
		},
		onRemoveQuestionAndAnswer: (state, { payload }) => {
			state.userSecurityQuestionAnswers.splice(payload, 1);
		},
		onUpdateAnswer: (state, { payload }) => {
			const {value, index} = payload;
			state.userSecurityQuestionAnswers[index].answer = value;
		},
		onUpdatePasswordForUpdateAnswers: (state, { payload }) => {
			state.passwordForUpdateAnswer.currentPassword = payload
		},
		onUpdateQuestion:  (state, { payload }) => {
			const {value, index} = payload;
			state.userSecurityQuestionAnswers[index].question = value;
		},
		onUpdateErrorQus: (state, { payload }) => {
			const {value, key} = payload;
			state.userSecurityQuestionAnswers[key].errorQuestion = value;
		},
		onUpdateErrorAns: (state, { payload }) => {
			const {value, key} = payload;	
			state.userSecurityQuestionAnswers[key].errorAnswer = value;
		},
		resetPassword : (state, { payload }) => {
			state.userData.oldPassword = "";
			state.userData.newPassword = "";
			state.userData.confirmPassword = "";
    	},
    	resetInit: (state, { payload }) => {
			state.userData = initialState.userData;
			state.userSecurityQuestionAnswers = initialState.userSecurityQuestionAnswers;
			state.passwordForUpdateAnswer = initialState.passwordForUpdateAnswer;
		},
		onUpdateAccountLoginHistory: (state, { payload }) => {
			state.accountLoginHistories = payload;
		}
	},
  });
  export const {
	updatePassWord,
	onUpdateFetchDataQuestionAndAnswer,
	onPushQuestionAndAnswer,
	onRemoveQuestionAndAnswer,
	onUpdateAnswer,
	onUpdatePasswordForUpdateAnswers,
	onUpdateQuestion,
	onUpdateErrorQus,
	onUpdateErrorAns,
  	resetPassword,
	onUpdateAccountLoginHistory,
  } = PasswordSecuritySlice.actions
export const PassworSecuritySelector = state => state.PasswordSecuritySlice;
export default PasswordSecuritySlice.reducer;



// WEBPACK FOOTER //
// ./src/app/slices/PasswordSecuritySlice.js